import React from "react";
import { Link } from "react-router-dom";

const NotFound: React.FC = () => {
  return (
    <div className="w-full bg-white relative overflow-hidden flex flex-col min-h-screen">
      <main className="flex-1 relative flex flex-col items-center justify-center py-[150px] overflow-hidden">
        {/* Huge background 404 text */}
        <div
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-[#F9F9F9] text-[300px] lg:text-[500px] font-title font-[400] pointer-events-none select-none z-0"
          style={{ lineHeight: 1 }}
        >
          404
        </div>

        {/* Content */}
        <div className="relative z-10 flex flex-col items-center gap-[32px] px-6 text-center">
          <div className="flex flex-col items-center gap-[6px]">
            <h1 className="text-[#212121] text-[48px] lg:text-[64px] font-[500] font-title leading-tight">
              Page Not Found
            </h1>
            <p className="max-w-[760px] text-[#919191] text-[18px] lg:text-[20px] font-description font-[400] leading-[1.6]">
              We couldn't find the page you were looking for. It may have been
              moved, renamed, or no longer exists. You can return to the
              homepage, browse our services, or contact us for further
              assistance.
            </p>
          </div>

          <Link
            to="/"
            className="w-[280px] h-[48px] px-[14px] py-[14px] bg-[#2776EA] rounded-[12px] flex items-center justify-center gap-[10px] hover:bg-[#1e5bb8] transition-colors shadow-lg"
          >
            <div className="w-6 h-6 relative flex items-center justify-center">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                <polyline points="9 22 9 12 15 12 15 22"></polyline>
              </svg>
            </div>
            <span className="text-white text-[16px] font-title font-[400]">
              Back to homepage
            </span>
          </Link>
        </div>
      </main>
    </div>
  );
};

export default NotFound;
